module.exports = __webpack_public_path__ + "img/client_logo_2.64e101d8.png";